import React, { useEffect, useRef } from 'react';
import { Calendar, Clock, Music, Mic, Trophy, Ticket, ArrowRight } from 'lucide-react';
import './Events.css';
import { trackEvent } from '../lib/analytics';

const EVENTBRITE_URL = 'https://www.eventbrite.com/o/royal-bar-grill-120928056108';

const Events = () => {
  const eventsRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('scroll-animate');
          }
        });
      },
      { threshold: 0.1 }
    );

    const cards = eventsRef.current?.querySelectorAll('.event-card');
    cards?.forEach((card) => observer.observe(card));

    return () => observer.disconnect();
  }, []);

  const events = [
  {
    day: 'Tuesday',
    icon: <Music size={32} />,
    title: 'Music Bingo',
    time: '6:30 PM',
    description: 'Test your music knowledge with our weekly Music Bingo night. Great prizes and even better atmosphere.'
  },
  {
    day: 'Wednesday',
    icon: <Trophy size={32} />,
    title: 'Royal Mix-Up Trivia',
    time: '6:00 PM',
    description: 'Put your knowledge to the test! Gather your team and compete for prizes in our weekly trivia challenge.'
  },
  {
    day: 'Thursday',
    icon: <Trophy size={32} />,
    title: 'Xtreme Bar Bingo',
    time: '6:00 PM',
    description: 'High-energy bingo with cash jackpots. Bring your competitive spirit and luck for a chance to win big.',
    highlight: 'Cash Jackpots'
  },
  {
    day: 'Friday',
    icon: <Mic size={32} />,
    title: 'Karaoke Night',
    time: '9:00 PM',
    description: 'Show off your vocal talents or cheer on brave performers. Full bar service and premium sound system.'
  },
  {
    day: '2nd & 4th Saturday',
    icon: <Music size={32} />,
    title: 'Line Dancing — Returns Soon (Temporarily Paused)',
    time: 'With Lessons',
    description: 'Put on your boots and hit the dance floor! Lessons included for beginners. Fun for all skill levels.',
    highlight: 'Lessons Included'
  },
  {
    day: '3rd Saturday',
    icon: <Mic size={32} />,
    title: 'Live Stand-Up Comedy',
    time: '7:00 PM',
    description: 'Monthly comedy showcase featuring talented local and touring comedians. Limited seating available.',
    highlight: 'Monthly Event'
  }];


  return (
    <section id="events" className="events-section">
      <div className="events-container">
        <div className="events-header section-header-animate">
          <span className="section-badge">WHAT'S HAPPENING</span>
          <h2 className="section-title-big">Weekly Events</h2>
          <p className="section-subtitle">Entertainment every week. Premium experience every night.</p>
          <a href={EVENTBRITE_URL} target="_blank" rel="noopener noreferrer" className="eventbrite-inline-link" data-testid="eventbrite-events-link" onClick={() => trackEvent('eventbrite_click', { link_location: 'events' })}>
            <Ticket size={16} />
            View Upcoming Events on Eventbrite
            <ArrowRight size={16} />
          </a>
        </div>

        <div className="events-grid" ref={eventsRef}>
          {events.map((event) =>
          <div key={`event-${event.day.toLowerCase().replace(/\s+/g, '-')}-${event.title.toLowerCase().replace(/\s+/g, '-')}`} className="event-card hover-lift">
              <div className="event-icon">{event.icon}</div>
              <div className="event-day">{event.day}</div>
              <h3 className="event-title">{event.title}</h3>
              <div className="event-time">
                <Clock size={16} />
                {event.time}
              </div>
              <p className="event-description">{event.description}</p>
              {event.highlight && <div className="event-highlight">{event.highlight}</div>
            }
            </div>
          )}
        </div>
      </div>
    </section>);

};

export default Events;